var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 13C0 5.8203 5.8203 0 13 0C20.1797 0 26 5.8203 26 13C26 20.1797 20.1797 26 13 26C5.8203 26 0 20.1797 0 13ZM17.9563 9.34375C18.525 9.2625 19.0125 9.18125 19.5 8.9375C19.175 9.50625 18.6875 9.99375 18.1187 10.3187C18.2812 14.1375 15.5188 18.2812 10.5625 18.2812C9.1 18.2812 7.71875 17.7937 6.5 17.0625C7.88125 17.225 9.34375 16.8187 10.3187 16.0875C9.1 16.0875 8.125 15.275 7.8 14.2188C8.20625 14.3 8.6125 14.2188 9.01875 14.1375C7.8 13.8125 6.90625 12.675 6.90625 11.4563C7.3125 11.6188 7.71875 11.7812 8.125 11.7812C6.9875 10.9688 6.58125 9.425 7.3125 8.20625C8.69375 9.83125 10.6438 10.8875 12.8375 10.9688C12.4313 9.34375 13.7312 7.71875 15.4375 7.71875C16.1687 7.71875 16.9 8.04375 17.3875 8.53125C18.0375 8.36875 18.6062 8.20625 19.0938 7.88125C18.9312 8.53125 18.525 9.01875 17.9563 9.34375Z",
    fill: "#919BB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.0864bf9fff2e4380cf98f4e38ef4938d.svg";
export { ForwardRef as ReactComponent };